
<template>
  <button type="button" class="btn bg-warning" v-bind:onclick="onclick" v-bind:name="name" v-bind:value="value" v-bind:id="id" data-popup="tooltip" v-bind:title="alt" v-bind:data-placement="altplacement">
    {{value}}
    <slot></slot>
  </button>

</template>

<script>
  export default {
    name: 'warning-button',
    components: {
    },
    props: [
      'value',
      'text',
      'alt',
      'altplacement',
      'placeholder',
      'name',
      'onclick',
      'checked',
      'id',
      'alerttext',
      'confirmtext',
      'okcallback',
      'cancelcallback',
    ],
    methods: {
      doAlert() {
        bootbox.alert({
          message: this.alerttext
        });
      },
      doConfirm() {
        bootbox.confirm({
          message: this.confirmtext,
          buttons: {
            confirm: {
              label: 'Yes',
              className: 'btn-primary'
            },
            cancel: {
              label: 'Cancel',
              className: 'btn-link'
            }
          },
          callback: this.doCallback
        });
      },
      doCallback(result) {
        if (result)
          eval(this.okcallback);
        else
          eval(this.cancelcallback);
      }

    },
    created() {
      
    },
    mounted() {
      if (typeof(this.alerttext) != "undefined")
      {
      $('#' + this.id).on('click', this.doAlert);
      }

      if (typeof (this.confirmtext) != "undefined") {
        $('#' + this.id).on('click', this.doConfirm);
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/form-components/buttons/warning-button.vue